import { Component, computed, Directive, input } from '@angular/core';
import { cn } from './cn';

@Component({
  selector: 'hlm-card',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {
    '[class]': '_computedClass()',
  },
})
export class HlmCardComponent {
  readonly userClass = input<string>('', { alias: 'class' });
  protected readonly _computedClass = computed(() =>
    cn(
      'rounded-xl border border-border bg-card text-card-foreground shadow-sm',
      this.userClass(),
    ),
  );
}

@Directive({
  selector: '[hlmCardHeader]',
  standalone: true,
  host: { '[class]': '_computedClass()' },
})
export class HlmCardHeaderDirective {
  readonly userClass = input<string>('', { alias: 'class' });
  protected readonly _computedClass = computed(() =>
    cn('flex flex-col space-y-1.5 p-6', this.userClass()),
  );
}

@Directive({
  selector: '[hlmCardTitle]',
  standalone: true,
  host: { '[class]': '_computedClass()' },
})
export class HlmCardTitleDirective {
  readonly userClass = input<string>('', { alias: 'class' });
  protected readonly _computedClass = computed(() =>
    cn('text-lg font-semibold leading-none tracking-tight', this.userClass()),
  );
}

@Directive({
  selector: '[hlmCardContent]',
  standalone: true,
  host: { '[class]': '_computedClass()' },
})
export class HlmCardContentDirective {
  readonly userClass = input<string>('', { alias: 'class' });
  protected readonly _computedClass = computed(() =>
    cn('p-6 pt-0', this.userClass()),
  );
}
